import { heliosApi } from '.';
import type { runHeliosHegFunctionReq, runHeliosHegFunctionRes, runHeliosHegWorkflowFunctionReq } from 'types/helios/runFunctions';
import { TAG_TYPES } from 'types/services';

const dispatchNotificationRefresh = () => {
  window.dispatchEvent(new CustomEvent('flowio:refresh-notifications'));
};

export const heliosRunFunctionsService = heliosApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    runHeliosHegFunction: builder.mutation<runHeliosHegFunctionRes, runHeliosHegFunctionReq>({
      query: (data) => ({
        url: 'RunFunction',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: [
        { type: TAG_TYPES.DATA_HELIOS },
        { type: TAG_TYPES.DATA_TABLES_HELIOS },
        { type: TAG_TYPES.TEMPLATES, id: 'LIST' },
        { type: TAG_TYPES.FILES },
      ],
      onQueryStarted: async (_arg, { queryFulfilled }) => {
        try {
          await queryFulfilled;
          dispatchNotificationRefresh();
        } catch {
          // request failure is surfaced to the mutation caller
        }
      },
    }),
    runHeliosHegWorkflowFunction: builder.mutation<void, runHeliosHegWorkflowFunctionReq>({
      query: (data) => ({
        url: 'RunWorkflowAction',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: [
        { type: TAG_TYPES.DATA_HELIOS },
        { type: TAG_TYPES.DATA_TABLES_HELIOS },
        { type: TAG_TYPES.TEMPLATES, id: 'LIST' },
        { type: TAG_TYPES.FILES },
      ],
      onQueryStarted: async (_arg, { queryFulfilled }) => {
        try {
          await queryFulfilled;
          dispatchNotificationRefresh();
        } catch {
          // request failure is surfaced to the mutation caller
        }
      },
    }),
  }),
});
export const { useRunHeliosHegFunctionMutation, useRunHeliosHegWorkflowFunctionMutation } = heliosRunFunctionsService;
